// extracted by mini-css-extract-plugin
export default {"remove-item":"ContextMenuItems_remove-item__FuBCS","disabled":"ContextMenuItems_disabled__qsupb","groups":"ContextMenuItems_groups__y8SeM"};